import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiPanel,
  EuiSpacer,
  EuiText,
} from "@inscopix/ideas-eui";
import { ProjectActions } from "components/ProjectActions/ProjectActions";
import {
  ProjectForm,
  ProjectFormMode,
} from "components/ProjectForm/ProjectForm";
import { useProjectDataContext } from "pages/project/ProjectDataProvider";
import { useProjectPermissionStore } from "pages/project/ProjectPermissionProvider";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";

export function ProjectTabSettings() {
  const { project } = useProjectDataContext();
  const currentTenantKey = useTenantContext((s) => s.currentTenant.key);
  const hasEditPermission = useProjectPermissionStore(
    (s) => s.permissions.edit,
  );
  return (
    <EuiFlexGroup>
      <EuiFlexItem
        grow={false}
        style={
          // 400px max form width + 24 px padding each side
          { maxWidth: "488px" }
        }
      >
        <EuiPanel hasShadow={false} hasBorder={true}>
          <EuiText size="s">
            <h3>Settings</h3>
          </EuiText>
          <EuiSpacer size="s" />
          <ProjectForm
            mode={ProjectFormMode.EDIT}
            project={project}
            tenantId={project.tenantId}
            readOnly={!hasEditPermission}
          />
        </EuiPanel>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiPanel hasShadow={false} hasBorder={true} style={{ flexGrow: 0 }}>
          <ProjectActions projectId={project.id} tenantKey={currentTenantKey} />
        </EuiPanel>
      </EuiFlexItem>
    </EuiFlexGroup>
  );
}
